import i18n from "i18next";
import moment from "moment";

export function isEmailValid(email: string) {
    const EMAIL_VALIDATION_REGEX = /\S+@\S+\.\S+/;
    return EMAIL_VALIDATION_REGEX.test(email);
}

export function toLowerCase(object: any): any {
    if (Array.isArray(object)) {
        return object.map(toLowerCase);
        // eslint-disable-next-line
    } else if (object !== null && typeof object === "object") {
        return Object.fromEntries(
            Object.entries(object).map(([key, value]: any) => [
                key,
                toLowerCase(value),
            ])
        );
    } else if (typeof object === "string") {
        return object.toLowerCase();
    } else {
        return object;
    }
}

export function truncateString(string: string, maxLength: number): string {
    return string?.length > maxLength
        ? `${string?.slice(0, maxLength)}...`
        : string;
}

export function getLastXDaysInTimestamp(lastXDays: number): string[] {
    const array: number[] = [];

    for (let i = 0; i < lastXDays; i += 1) {
        array.push(i);
    }

    return array
        .map((day: number) => {
            return Math.trunc(
                moment(
                    new Date(
                        moment().subtract(1, "days").unix() * 1000
                    ).getTime() -
                        86400000 * day
                ).unix()
            );
        })
        .sort()
        .map(String);
}

export function getAdvancedSeeMorePeriod(
    period: string,
    advancedDate: {
        startDate: string;
        endDate: string;
    }
) {
    if (advancedDate.startDate !== "" && advancedDate.endDate !== "") {
        return {
            startDate: advancedDate.startDate,
            endDate: advancedDate.endDate,
        };
    }

    if (period === i18n.t("Current week")) {
        return {
            startDate: String(moment().startOf("week").unix()),
            endDate: String(moment().endOf("week").unix()),
        };
    }

    if (period === i18n.t("Current month")) {
        return {
            startDate: String(moment().startOf("month").unix()),
            endDate: String(moment().endOf("month").unix()),
        };
    }

    if (period === i18n.t("Current year")) {
        return {
            startDate: String(moment().startOf("year").unix()),
            endDate: String(moment().endOf("year").unix()),
        };
    }

    if (period === i18n.t("Last Month")) {
        return {
            startDate: String(
                moment().subtract(1, "month").startOf("month").unix()
            ),
            endDate: String(
                moment().subtract(1, "month").endOf("month").unix()
            ),
        };
    }

    if (period === i18n.t("The last 7 days")) {
        const timestamps = getLastXDaysInTimestamp(7);
        return {
            startDate: timestamps[0],
            endDate: timestamps[6],
        };
    }

    if (period === i18n.t("Last Week")) {
        return {
            startDate: moment().subtract(1, "week").startOf("week").toDate(),
            endDate: moment().subtract(1, "week").endOf("week").toDate(),
        };
    }

    if (period === i18n.t("The last 30 days")) {
        const timestamps = getLastXDaysInTimestamp(30);
        return {
            startDate: timestamps[0],
            endDate: timestamps[29],
        };
    }
    if (period === i18n.t("Today")) {
        const todayStart = moment().startOf("day").unix();
        const todayEnd = moment().endOf("day").unix();

        return {
            startDate: todayStart,
            endDate: todayEnd,
        };
    }

    // Fallback return if none of the conditions match
    return {
        startDate: "",
        endDate: "",
    };
}

export function getAdvancedPeriodStringParam(
    period: any,
    advancedDate: { startDate: string; endDate: string }
): string {
    if (period.date === i18n.t("Today")) {
        return "today";
    }

    if (advancedDate.startDate !== "" && advancedDate.endDate !== "") {
        return `start_date=${advancedDate.startDate}&end_date=${advancedDate.endDate}`;
    }

    if (period.date === i18n.t("Current week")) {
        return "week";
    }
    if (period.date === i18n.t("Current Month")) {
        return "month";
    }
    if (period.date === i18n.t("This Year")) {
        return "year";
    }

    if (period.date === i18n.t("The last 7 days")) {
        return "last_seven_days";
    }

    if (period.date === i18n.t("The last 30 days")) {
        return "last_thirty_days";
    }

    return "month";
}

export async function downloadStoreReportCsv(
    fileName: string,
    merchentAccount: string
) {

    const response = await fetch(
        `${process.env.REACT_APP_ADMIN_ACCESS}/downloadStoreReportCsv?repportFileName=${fileName}&merchentAccount=${merchentAccount}`,
        {
            method: "GET",
        }
    );

    if (!response.ok) {
        throw new Error("Failed to download CSV");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);

    return true;
}
